import { createContext, useContext } from 'react';
import type { ModeT } from '../../types';

interface OpenEndedPresentationContext {
  shouldAnimate: boolean;
  isReadonly: boolean;
  mode: ModeT;
  visualization: 'flowing_grid' | 'speech_bubbles';

  // title stuff
  title: string;
  styledTitle: Record<string, unknown>;
  description: string;
  label: string;
  textSizeOffset: -2 | -1 | 0 | 1 | 2;
}

export const OpenEndedPresentationContext = createContext<
  OpenEndedPresentationContext | undefined
>(undefined);

export const useOpenEndedPresentationContext = () => {
  const openEndedPresentationContext = useContext(OpenEndedPresentationContext);
  if (!openEndedPresentationContext)
    throw new Error(
      'No OpenEndedPresentationContext.Provider found when calling useOpenEndedPresentationContext.',
    );
  return openEndedPresentationContext;
};
